import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { TransactionTag as OldTransactionTagModel } from "@models/transaction";

export interface TransactionTag {
	readonly type: string;
	attribute: TransactionAttribute;
}

export interface TransactionAttribute {
	readonly shortName: string;
	readonly name: string;
}

export class TransactionTagAdapter extends BaseAdapter<OldTransactionTagModel, TransactionTag> {
	public adapt(item: OldTransactionTagModel): TransactionTag {
		if (!item) {
			return null;
		}

		return {
			type: item.type,
			attribute: {
				name: item.attributes.name,
				shortName: item.attributes.short_name
			}
		};
	}
}
